import { handleActions } from 'redux-actions';
import { INIT } from '../../actions/types';

export const INITIAL_STATE = {
  keyword: null,
  articleUrl: null,
  hideCloseButton: false,
};

export const reducer = handleActions(
  {
    [INIT]: (state, { payload }) => ({
      ...payload.customOptions,
    }),
  },
  INITIAL_STATE,
);
